import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Footer } from '../Footer';
import { Outlet, useLocation } from 'react-router-dom';
import { useSidebar } from '@frontend/features/dashboard/contexts/SidebarContext/hook';
import { routes } from '@frontend/router/routes';
import { PaymentMethods } from './paymentMethods';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { HEADER_HEIGHT, SUB_LAYOUT_HEIGHT_MARGIN_LARGE, SUB_LAYOUT_HEIGHT_MARGIN_SMALL } from '../../constants/layout';

interface SublayoutProps {
  noFooter?: boolean;
  noPayments?: boolean;
  noMt?: boolean;
  noLargeDownMt?: boolean;
  isBackOffice?: boolean;
}

const useGetMarginTop = (noMt?: boolean, noLargeDownMt?: boolean, isBackOffice?: boolean) => {
  const { isLargeDown, isLargeUp } = useBreakpoints();
  const { headerHeight } = useSidebar();
  const { pathname } = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile && isBackOffice) return 0;

  if (noMt) {
    return 0;
  } else if (isLargeDown && noLargeDownMt) {
    return 0;
  } else if (isLargeDown && isBackOffice) {
    return 8;
  } else if (!isLargeDown && isBackOffice) {
    return 0;
  }

  if (pathname === routes.hotels.home) {
    // Explicit pixels: numeric MUI margins are spacing units, not measured pixels.
    return headerHeight === undefined ? 16 : `${headerHeight}px`;
  }

  if (isMobile) return `${headerHeight ?? HEADER_HEIGHT}px`;

  return isLargeUp ? 8 : 16;
};

export const Sublayout = ({ noFooter, noPayments, noMt, noLargeDownMt, isBackOffice }: SublayoutProps) => {
  const { isLargeUp } = useBreakpoints();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const outletMarginTop = useGetMarginTop(noMt, noLargeDownMt, isBackOffice);
  return (
    <Box bgcolor="paper.background" display="flex" flexDirection="column" justifyContent="space-between" height="100%">
      <Box
        mt={outletMarginTop}
        height={
          isBackOffice && isMobile
            ? '100%'
            : isBackOffice
              ? `calc(100vh - ${isLargeUp ? SUB_LAYOUT_HEIGHT_MARGIN_LARGE : SUB_LAYOUT_HEIGHT_MARGIN_SMALL})`
              : 'auto'
        }
      >
        <Outlet />
      </Box>
      <Box>
        {!noPayments && <PaymentMethods />}
        {!noFooter && <Footer />}
      </Box>
    </Box>
  );
};
